/* dv-sabit-rulo.js — [DV-SABIT-RULO 2026-08-01] + [DV-SR-V2 2026-08-02]
   Yuvarlak/Oval sayfalarini kesim (rulo) mantigina baglar.

   V2 (yeni): olculer Shopify varyantindan DEGIL, elimizdeki TOPLARDAN uretilir.
     window.__DV_SABIT_RULO_V2__ icinde handle varsa V2 calisir:
       - yerel BOYUT secicisi gizlenir, yerine rulodan uretilmis olcu dugmeleri basilir
       - fiyat = kesim birim fiyati(rulo eni) x boy(cm)
       - her dugme icin canli Nebim rulo stogu sorgulanir (check-roll-availability)
       - sepet: Model A gizli kesim kalemi (varyant=rulo eni, adet=boy cm)
   V1 (eski): V2'de handle yoksa window.__DV_SABIT_RULO__ ile varyant-eslesmeli eski akis calisir.
   Iki haritada da yoksa script hicbir seye DOKUNMAZ. */
(function () {
  'use strict';
  var TAG = '[DVSabitRulo]';

  function fmtTL(n) {
    return Number(n).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' TL';
  }

  /* ══════════════════════════════════════════════════════════════
     ORTAK YARDIMCILAR
     ══════════════════════════════════════════════════════════════ */
  function stokMsgEl() {
    var id = 'dv-sr-stok';
    var el = document.getElementById(id);
    if (!el) {
      el = document.createElement('div');
      el.id = id;
      el.style.cssText = 'margin:8px 0;font-size:13px;line-height:1.4;';
      var host = document.querySelector('.hdt-product__buy-button') || document.querySelector('form[action*="/cart/add"]');
      if (host) host.parentNode.insertBefore(el, host);
    }
    return el;
  }
  function toggleMsg(html, renk) {
    var el = stokMsgEl();
    if (!html) { el.style.display = 'none'; el.innerHTML = ''; return; }
    el.style.display = '';
    el.style.color = renk || '#1a7f37';
    el.innerHTML = html;
  }
  function setAtc(disabled, label) {
    document.querySelectorAll('form[action*="/cart/add"] [type="submit"], form[action*="/cart/add"] [name="add"]').forEach(function (b) {
      b.disabled = !!disabled;
      if (label !== undefined) {
        var sp = b.querySelector('span') || b;
        if (!b.__dvSrOrig) b.__dvSrOrig = sp.textContent;
        sp.textContent = label || b.__dvSrOrig;
      }
    });
  }
  function hidePaymentButtons() {
    document.querySelectorAll('form[action*="/cart/add"] .shopify-payment-button').forEach(function (e) { e.style.display = 'none'; });
  }
  /* Adet girisi bu temada FORMUN DISINDA duruyor (form="..." nitelikli). form.querySelector ile
     bulunamadigi icin adet her zaman 1 sayiliyordu — [DV-SR-ADET-FIX 2026-08-02]. */
  function adetAl(form) {
    var q = form ? form.querySelector('[name="quantity"]') : null;
    if (!q && form && form.id) q = document.querySelector('[name="quantity"][form="' + form.id + '"]');
    if (!q) q = document.querySelector('form[action*="/cart/add"] [name="quantity"], .hdt-quantity__input[name="quantity"], [name="quantity"]');
    var n = parseInt(q && q.value, 10) || 1;
    return Math.max(1, Math.min(5, n));
  }

  /* Sepete ekleme — V1 ve V2 ortak (r: {en,boy,rulo,bar,kvid,birim,fiyat}) */
  function sepeteEkle(r, adet, cfgAd, SEKIL, handle) {
    var satir = Math.round(r.birim * r.boy * 100) / 100;
    if (Math.abs(satir - r.fiyat) > 0.01) { // FIYAT KAPISI
      console.error(TAG, 'FIYAT KAPISI kapali', satir, r.fiyat);
      alert('Fiyat doğrulaması başarısız oldu, ürün sepete eklenmedi.');
      return Promise.reject(new Error('fiyat kapisi'));
    }
    var kok = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var zincir = Promise.resolve();
    var sonYanit = null;
    for (var i = 0; i < adet; i++) {
      (function (son) {
        zincir = zincir.then(function () {
          var props = {
            'Model': cfgAd,
            'Halı Şekli': SEKIL,
            'Genişlik': r.en + 'cm (' + r.rulo + 'cm rulo)',
            'Uzunluk': r.boy + 'cm',
            'Kenar Tipi': 'Overlok',
            'Toplam m²': ((r.rulo * r.boy) / 10000).toFixed(2),
            '_rollBarcode': r.bar,
            '_snapWidth': String(r.rulo),
            '_edgeType': 'overlok',
            '_shapeType': SEKIL === 'Oval' ? 'oval' : 'daire',
            '_sabitOlcu': r.en + 'x' + r.boy,
            '_satirId': 'sr_' + Date.now().toString(36) + '_' + Math.random().toString(36).substr(2, 5),
            '_kesimVaryantId': String(r.kvid),
            '_birimFiyat': String(r.birim),
            '_sayfaTutar': String(r.fiyat),
            // [DV-SEPET-LINK 2026-08-02] sepet satiri gercek urune linklensin
            '_kaynakUrl': kok + 'products/' + handle
          };
          if (window.__DV_SR_IMG__) props['Onizleme'] = window.__DV_SR_IMG__;
          var sections = [];
          if (son) {
            try { document.dispatchEvent(new CustomEvent('cart:push:section.id', { bubbles: true, detail: { sections: sections } })); } catch (e) {}
          }
          var fd = new FormData();
          fd.append('id', String(r.kvid));
          fd.append('quantity', String(r.boy));
          Object.keys(props).forEach(function (k) {
            if (props[k] === null || props[k] === undefined || props[k] === '') return;
            fd.append('properties[' + k + ']', String(props[k]));
          });
          if (sections.length) fd.append('sections', sections.join(','));
          return fetch(kok + 'cart/add.js', { method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest' } })
            .then(function (resp) {
              return resp.json().catch(function () { return null; }).then(function (data) {
                if (!resp.ok) throw new Error((data && (data.description || data.message)) || 'Ürün sepete eklenemedi.');
                if (son) sonYanit = data;
                return data;
              });
            });
        });
      })(i === adet - 1);
    }
    return zincir.then(function () {
      return fetch(kok + 'cart.js', { credentials: 'same-origin' }).then(function (x) { return x.json(); }).then(function (cart) {
        if (sonYanit && sonYanit.sections) cart.sections = sonYanit.sections;
        document.dispatchEvent(new CustomEvent('cart:change', {
          bubbles: true,
          detail: { baseEvent: 'variant:add', actionAfterATC: 'open_cart_drawer', cart: cart }
        }));
        console.log(TAG, 'sepete eklendi:', cfgAd, r.en + 'x' + r.boy, '=', fmtTL(r.fiyat), 'x', adet);
        return true;
      });
    });
  }

  /* ══════════════════════════════════════════════════════════════
     V2 — OLCULER RULODAN URETILIR
     ══════════════════════════════════════════════════════════════ */
  function initV2(DATA, cfg, handle) {
    var API = DATA.api;
    var SEKIL = cfg.sekil;                 // 'Yuvarlak' | 'Oval'
    var OLC = cfg.olculer || [];           // [{en,boy,rulo,bar,kvid,birim,fiyat,vid}]
    if (!OLC.length) return;
    var sec = 0;
    var stokCache = {};                    // bar|boy -> {t,data}
    var STOK_TTL = 60000;
    var busy = false;
    var applying = false;
    var OLCU_ID = 'dv-sr-olcu';

    function rec() { return OLC[sec] || null; }

    /* [DV-SR-ATC-ETIKET 2026-08-02] Sepete-ekle butonundaki metin iki sorun cikariyordu:
       (a) tema, Shopify varyanti tukendiyse "Tükendi" yaziyor — oysa satis RULO stoguna bagli,
       (b) indirim betigi "· Sepette X TL" yaziyor ama X'i ESKI varyant fiyatindan hesapliyor.
       Cozum: indirim oranini ilk okumada yakala, tutari BIZIM fiyattan yeniden hesapla;
       oran okunamazsa yaniltici sayiyi hic gosterme. */
    var ILK_VARYANT_KURUS = (function () {
      var qp = document.querySelector('form[action*="/cart/add"] hdt-qty-price');
      return qp ? (parseInt(qp.getAttribute('variant-price'), 10) || 0) : 0;
    })();
    var SEPETTE_ORAN = null;
    function oranYakala() {
      if (SEPETTE_ORAN !== null || !ILK_VARYANT_KURUS) return;
      var sp = document.querySelector('form[action*="/cart/add"] .hdt-btn-atc_text');
      var m = sp && (sp.textContent || '').match(/Sepette\s+([\d.]+,\d{2})/);
      if (!m) return;
      var v = parseFloat(m[1].replace(/\./g, '').replace(',', '.'));
      var o = v / (ILK_VARYANT_KURUS / 100);
      if (o > 0.5 && o < 1) SEPETTE_ORAN = o;
    }
    function atcEtiket() {
      var r = rec();
      if (r && SEPETTE_ORAN) return 'Sepete ekle · Sepette ' + fmtTL(Math.round(r.fiyat * SEPETTE_ORAN * 100) / 100);
      return 'Sepete ekle';
    }
    var sonUygun = null; // true=stok var, false=yok, null=bilinmiyor

    // ── baslangic secimi: sayfada secili varyanta karsilik gelen olcu, yoksa varyanti olan ilk olcu ──
    (function () {
      var el = document.querySelector('form[action*="/cart/add"] [name="id"]');
      var v = el ? String(el.value) : null;
      var i = v ? OLC.findIndex(function (o) { return String(o.vid) === v; }) : -1;
      if (i < 0) i = OLC.findIndex(function (o) { return o.vid; });
      sec = i < 0 ? 0 : i;
    })();

    // ── yerel BOYUT secicisini gizle ──
    function yerelOlcuFieldset() {
      var fss = document.querySelectorAll('hdt-variant-picker fieldset, .hdt-product__variant-picker fieldset');
      for (var i = 0; i < fss.length; i++) {
        var vals = fss[i].querySelectorAll('input');
        for (var j = 0; j < vals.length; j++) {
          if (/^\s*\d{2,3}\s*[xX]\s*\d{2,3}\s*$/.test(vals[j].value || '')) return fss[i];
        }
      }
      return null;
    }
    function gizleYerelSecici() {
      var fs = yerelOlcuFieldset();
      if (fs) { fs.style.setProperty('display', 'none', 'important'); fs.setAttribute('data-dv-sr-hidden', '1'); }
      return fs;
    }

    // ── kendi olcu bloğumuz ──
    function stil() {
      if (document.getElementById('dv-sr-css')) return;
      var s = document.createElement('style');
      s.id = 'dv-sr-css';
      s.textContent =
        '#' + OLCU_ID + '{margin:0 0 18px}' +
        '#' + OLCU_ID + ' .dv-sr-lbl{font-size:14px;margin:0 0 8px;display:block}' +
        '#' + OLCU_ID + ' .dv-sr-lbl b{font-weight:600}' +
        '#' + OLCU_ID + ' .dv-sr-wrap{display:flex;flex-wrap:wrap;gap:8px}' +
        '#' + OLCU_ID + ' .dv-sr-btn{position:relative;cursor:pointer;border:1px solid #d7d7d7;background:#fff;color:#111;' +
        'border-radius:6px;padding:9px 14px;font-size:14px;line-height:1;min-width:78px;text-align:center;transition:.15s}' +
        '#' + OLCU_ID + ' .dv-sr-btn:hover{border-color:#111}' +
        '#' + OLCU_ID + ' .dv-sr-btn.sel{border-color:#111;background:#111;color:#fff}' +
        '#' + OLCU_ID + ' .dv-sr-btn.yok{opacity:.45}' +
        '#' + OLCU_ID + ' .dv-sr-btn.yok:after{content:"";position:absolute;left:6%;right:6%;top:50%;height:1px;background:currentColor}' +
        '#' + OLCU_ID + ' .dv-sr-fiy{display:block;font-size:11px;opacity:.75;margin-top:4px;line-height:1}';
      document.head.appendChild(s);
    }
    function mount() {
      stil();
      var fs = gizleYerelSecici();
      var el = document.getElementById(OLCU_ID);
      if (!el) {
        el = document.createElement('div');
        el.id = OLCU_ID;
        var anchor = fs || document.querySelector('hdt-variant-picker') || document.querySelector('.hdt-product__variant-picker');
        if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(el, anchor.nextSibling);
        else {
          var host = document.querySelector('.hdt-product__buy-button') || document.querySelector('form[action*="/cart/add"]');
          if (!host) return null;
          host.parentNode.insertBefore(el, host);
        }
      }
      return el;
    }
    function ciz() {
      var el = mount();
      if (!el) return;
      var r = rec();
      var h = '<span class="dv-sr-lbl">BOYUT: <b>' + (r ? r.en + 'x' + r.boy + ' cm' : '') + '</b></span><div class="dv-sr-wrap">';
      OLC.forEach(function (o, i) {
        h += '<button type="button" class="dv-sr-btn' + (i === sec ? ' sel' : '') + (o.__yok ? ' yok' : '') +
             '" data-i="' + i + '" title="' + o.rulo + ' cm rulodan">' + o.en + 'x' + o.boy +
             '<span class="dv-sr-fiy">' + fmtTL(o.fiyat) + '</span></button>';
      });
      el.innerHTML = h + '</div>';
    }

    // ── fiyat ──
    function applyPrice() {
      var r = rec();
      if (!r) return;
      applying = true;
      try {
        document.querySelectorAll('.hdt-product__price .hdt-price__list').forEach(function (pl) {
          pl.querySelectorAll('.hdt-compare-at-price').forEach(function (e) { e.style.display = 'none'; });
          pl.querySelectorAll('.discount-badge').forEach(function (e) { e.remove(); });
          var sale = pl.querySelector('.hdt-price-item, .hdt-money, [class*="price"]');
          var target = null;
          var cands = pl.querySelectorAll('span, div, bdi');
          for (var i = 0; i < cands.length; i++) {
            var t = (cands[i].textContent || '').trim();
            if (/\d/.test(t) && /TL|₺/.test(t) && cands[i].children.length === 0 && cands[i].offsetParent !== null) { target = cands[i]; break; }
          }
          if (!target && sale) target = sale;
          if (target && target.textContent.trim() !== fmtTL(r.fiyat)) target.textContent = fmtTL(r.fiyat);
        });
        // [DV-SR-FIXED3 2026-08-02] Tokyo vb. sayfalar farkli fiyat sablonu kullaniyor
        document.querySelectorAll('.dv-fixed-option3__current-price').forEach(function (e) {
          if (e.textContent.trim() !== fmtTL(r.fiyat)) e.textContent = fmtTL(r.fiyat);
        });
        document.querySelectorAll('.dv-fixed-option3__list-price').forEach(function (e) { e.style.display = 'none'; });
        document.querySelectorAll('.taksit-tutari').forEach(function (el) {
          el.textContent = (r.fiyat / 6).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        });
        // sepete ekle butonundaki tutar (tema: <hdt-qty-price variant-price="kurus"><span class="hdt-money">)
        var kurus = String(Math.round(r.fiyat * 100));
        document.querySelectorAll('form[action*="/cart/add"] hdt-qty-price').forEach(function (qp) {
          if (qp.getAttribute('variant-price') !== kurus) qp.setAttribute('variant-price', kurus);
          var adet = adetAl(qp.closest('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]'));
          var mny = qp.querySelector('.hdt-money');
          var yazi = fmtTL(r.fiyat * adet);
          if (mny && mny.textContent.trim() !== yazi) mny.textContent = yazi;
        });
      } finally {
        setTimeout(function () { applying = false; }, 0);
      }
    }

    // ── stok ──
    function checkStock(r, taze, cb) {
      var key = r.bar + '|' + r.boy;
      var c = stokCache[key];
      if (!taze && c && Date.now() - c.t < STOK_TTL) { cb(c.data); return; }
      fetch(API + '/check-roll-availability?barcode=' + encodeURIComponent(r.bar) + '&length=' + (r.boy / 100) + (taze ? '&_t=' + Date.now() : ''))
        .then(function (x) { return x.json(); })
        .then(function (d) { stokCache[key] = { t: Date.now(), data: d }; cb(d); })
        .catch(function () { cb(null); });
    }
    function applyStock() {
      var r = rec();
      if (!r) return;
      toggleMsg('Stok kontrol ediliyor…', '#666');
      checkStock(r, false, function (d) {
        if (rec() !== r) return; // secim degisti
        if (d && d.available) {
          r.__yok = false; sonUygun = true;
          oranYakala(); setAtc(false, atcEtiket()); applyPrice();
          toggleMsg('✓ ' + r.rulo + ' cm ruloda ' + (d.suitableRollCount || '') + ' uygun top mevcut');
        } else if (d) {
          r.__yok = true; sonUygun = false;
          setAtc(true, 'TÜKENDİ');
          toggleMsg('Bu ölçü için uygun rulo stoğu şu an yok.', '#b3261e');
        } else {
          sonUygun = null; setAtc(false); toggleMsg(null); // servis yanit vermiyorsa satisi kilitleme
        }
        ciz();
      });
    }
    // tum olculerin stogunu arka planda tara (dugmeleri isaretlemek icin)
    function stokTara() {
      var i = 0;
      function sonraki() {
        if (i >= OLC.length) { ciz(); return; }
        var o = OLC[i++];
        checkStock(o, false, function (d) {
          if (d) o.__yok = !d.available;
          ciz();
          sonraki();
        });
      }
      sonraki();
    }

    // ── secim ──
    function secDegistir(i) {
      if (i === sec || !OLC[i]) return;
      sec = i;
      // tema formunu mumkunse hizala (varyanti olan olculerde)
      var el = document.querySelector('form[action*="/cart/add"] [name="id"]');
      if (el && OLC[i].vid) el.value = String(OLC[i].vid);
      ciz(); applyPrice(); applyStock();
    }

    // ── sepete ekleme kesintisi ──
    function intercept(ev) {
      var t = ev.target && ev.target.closest ? ev.target.closest('form[action*="/cart/add"] [type="submit"], form[action*="/cart/add"] [name="add"]') : null;
      if (!t) return;
      var form = t.closest('form[action*="/cart/add"]');
      ev.preventDefault();
      ev.stopImmediatePropagation();
      ekleAkisi(form);
    }
    function ekleAkisi(form) {
      var r = rec();
      if (!r || !form) return;
      if (busy) return;
      busy = true;
      var adet = adetAl(form);
      toggleMsg('Stok kontrol ediliyor…', '#666');
      checkStock(r, true, function (d) {
        if (!d || !d.available) {
          r.__yok = true; ciz();
          setAtc(true, 'TÜKENDİ');
          toggleMsg('Stok durumu değişti — bu ölçü için uygun rulo yok.', '#b3261e');
          busy = false;
          return;
        }
        toggleMsg(null);
        sepeteEkle(r, adet, cfg.ad, SEKIL, handle)
          .catch(function (e) { console.error(TAG, e); toggleMsg('Sepete eklenemedi: ' + e.message, '#b3261e'); })
          .then(function () { busy = false; });
      });
    }

    // ── baglantilar ──
    document.addEventListener('click', function (ev) {
      var b = ev.target && ev.target.closest ? ev.target.closest('#' + OLCU_ID + ' .dv-sr-btn') : null;
      if (b) { ev.preventDefault(); secDegistir(parseInt(b.getAttribute('data-i'), 10)); return; }
      intercept(ev);
    }, true);
    document.addEventListener('submit', function (ev) {
      var form = ev.target;
      if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
      ev.preventDefault(); ev.stopImmediatePropagation();
      ekleAkisi(form);
    }, true);

    var mo = new MutationObserver(function () { if (!applying) applyPrice(); });
    ['.hdt-product__price', '.dv-fixed-option3__price-row'].forEach(function (s) {
      var host = document.querySelector(s);
      if (host) mo.observe(host, { childList: true, subtree: true, characterData: true });
    });

    document.addEventListener('change', function (ev) {
      if (ev.target && ev.target.name === 'quantity') applyPrice();
    }, true);

    setInterval(function () {
      if (!document.getElementById(OLCU_ID)) ciz();
      else gizleYerelSecici();
      oranYakala();
      applyPrice();
      if (sonUygun === true) setAtc(false, atcEtiket());
      else if (sonUygun === false) setAtc(true, 'TÜKENDİ');
      hidePaymentButtons();
    }, 800);

    hidePaymentButtons();
    ciz();
    applyPrice();
    applyStock();
    stokTara();
    console.log(TAG, 'V2 aktif:', handle, OLC.length + ' olcu (rulodan uretildi)');
  }

  /* ══════════════════════════════════════════════════════════════
     V1 — ESKI AKIS (varyant eslesmeli). Degistirilmedi.
     ══════════════════════════════════════════════════════════════ */
  function initV1(DATA, cfg, handle) {
    var API = DATA.api;
    var SEKIL = cfg.sekil;
    var stokCache = {};
    var STOK_TTL = 60000;
    var busy = false;
    var applying = false;

    function currentVid() {
      var el = document.querySelector('form[action*="/cart/add"] input[name="id"], form[action*="/cart/add"] select[name="id"]');
      return el ? String(el.value) : null;
    }
    function rec(vid) { return vid ? cfg.olculer[String(vid)] : null; }

    function applyPrice() {
      var r = rec(currentVid());
      if (!r) { toggleMsg(null); return; }
      applying = true;
      try {
        document.querySelectorAll('.hdt-product__price .hdt-price__list').forEach(function (pl) {
          pl.querySelectorAll('.hdt-compare-at-price').forEach(function (e) { e.style.display = 'none'; });
          pl.querySelectorAll('.discount-badge').forEach(function (e) { e.remove(); });
          var sale = pl.querySelector('.hdt-price-item, .hdt-money, [class*="price"]');
          var target = null;
          var cands = pl.querySelectorAll('span, div, bdi');
          for (var i = 0; i < cands.length; i++) {
            var t = (cands[i].textContent || '').trim();
            if (/\d/.test(t) && /TL|₺/.test(t) && cands[i].children.length === 0 && cands[i].offsetParent !== null) { target = cands[i]; break; }
          }
          if (!target && sale) target = sale;
          if (target && target.textContent.trim() !== fmtTL(r.fiyat)) target.textContent = fmtTL(r.fiyat);
        });
        document.querySelectorAll('.taksit-tutari').forEach(function (el) {
          el.textContent = (r.fiyat / 6).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        });
      } finally {
        setTimeout(function () { applying = false; }, 0);
      }
    }
    function fixStickyLabels() {
      document.querySelectorAll('select[name="id"]').forEach(function (sel) {
        Array.prototype.forEach.call(sel.options, function (op) {
          var r = rec(op.value);
          if (!r) return;
          var base = op.textContent.split(' - ')[0].trim();
          op.textContent = base + ' - ' + fmtTL(r.fiyat);
        });
      });
    }
    function checkStock(r, cb) {
      var key = r.bar + '|' + r.boy;
      var c = stokCache[key];
      if (c && Date.now() - c.t < STOK_TTL) { cb(c.data); return; }
      fetch(API + '/check-roll-availability?barcode=' + encodeURIComponent(r.bar) + '&length=' + (r.boy / 100))
        .then(function (x) { return x.json(); })
        .then(function (d) { stokCache[key] = { t: Date.now(), data: d }; cb(d); })
        .catch(function () { cb(null); });
    }
    function applyStock() {
      var r = rec(currentVid());
      if (!r) { setAtc(false); toggleMsg(null); return; }
      toggleMsg('Stok kontrol ediliyor…', '#666');
      checkStock(r, function (d) {
        var g = rec(currentVid());
        if (!g || g !== r) return;
        if (d && d.available) {
          setAtc(false);
          toggleMsg('✓ ' + r.rulo + ' cm ruloda ' + (d.suitableRollCount || '') + ' uygun top mevcut');
        } else if (d) {
          setAtc(true, 'TÜKENDİ');
          toggleMsg('Bu ölçü için uygun rulo stoğu şu an yok.', '#b3261e');
        } else {
          setAtc(false);
          toggleMsg(null);
        }
      });
    }
    function intercept(ev) {
      var t = ev.target && ev.target.closest ? ev.target.closest('form[action*="/cart/add"] [type="submit"], form[action*="/cart/add"] [name="add"]') : null;
      if (!t) return;
      var form = t.closest('form[action*="/cart/add"]');
      var idEl = form && form.querySelector('[name="id"]');
      var r = rec(idEl && idEl.value);
      if (!r) return;
      ev.preventDefault();
      ev.stopImmediatePropagation();
      if (busy) return;
      busy = true;
      var adet = adetAl(form);
      toggleMsg('Stok kontrol ediliyor…', '#666');
      fetch(API + '/check-roll-availability?barcode=' + encodeURIComponent(r.bar) + '&length=' + (r.boy / 100) + '&_t=' + Date.now())
        .then(function (x) { return x.json(); })
        .then(function (d) {
          if (!d || !d.available) {
            setAtc(true, 'TÜKENDİ');
            toggleMsg('Stok durumu değişti — bu ölçü için uygun rulo yok.', '#b3261e');
            throw new Error('stok yok');
          }
          toggleMsg(null);
          return sepeteEkle(r, adet, cfg.ad, SEKIL, handle);
        })
        .catch(function (e) { if (e && e.message !== 'stok yok') { console.error(TAG, e); toggleMsg('Sepete eklenemedi: ' + e.message, '#b3261e'); } })
        .then(function () { busy = false; });
    }

    document.addEventListener('click', intercept, true);
    document.addEventListener('submit', function (ev) {
      var form = ev.target;
      if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
      var idEl = form.querySelector('[name="id"]');
      if (rec(idEl && idEl.value)) { ev.preventDefault(); ev.stopImmediatePropagation(); }
    }, true);
    document.addEventListener('change', function (ev) {
      if (ev.target && ev.target.name === 'id') { applyPrice(); applyStock(); }
      if (ev.target && ev.target.matches && ev.target.matches('input[type="radio"], select')) {
        setTimeout(function () { applyPrice(); applyStock(); }, 50);
      }
    }, true);
    var mo = new MutationObserver(function () { if (!applying) applyPrice(); });
    var priceHost = document.querySelector('.hdt-product__price');
    if (priceHost) mo.observe(priceHost, { childList: true, subtree: true, characterData: true });
    var lastVid = null;
    setInterval(function () {
      var v = currentVid();
      if (v !== lastVid) { lastVid = v; applyPrice(); applyStock(); fixStickyLabels(); }
    }, 600);

    hidePaymentButtons();
    fixStickyLabels();
    applyPrice();
    applyStock();
    console.log(TAG, 'V1 aktif:', handle, Object.keys(cfg.olculer).length + ' eslesmis olcu');
  }

  /* ══════════════════════════════════════════════════════════════ */
  function init() {
    var handle = window.__DV_SR_HANDLE__;
    if (!handle) return;
    var D2 = window.__DV_SABIT_RULO_V2__;
    if (D2 && D2.urunler && D2.urunler[handle]) { initV2(D2, D2.urunler[handle], handle); return; }
    var D1 = window.__DV_SABIT_RULO__;
    if (D1 && D1.urunler && D1.urunler[handle]) { initV1(D1, D1.urunler[handle], handle); return; }
    // kapsam disi — hicbir seye dokunma
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
